module.exports = __webpack_public_path__ + "static/media/central_ia.ba972ba8.svg";